import React from 'react'
import Box from '@material-ui/core/Box'
import Divider from '@material-ui/core/Divider'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Typography from '@material-ui/core/Typography'
import withWidth, { isWidthDown, WithWidthProps } from '@material-ui/core/withWidth'
import { useHistory, useLocation } from 'react-router-dom'
import { Routes } from '../../../consts'
import { useSubmitModelDialog } from '../../molecules/SubmitModelDialog/hooks'
import { useLogin } from '../Login'

interface Props {
  openSider: boolean
  setOpenSider: React.Dispatch<React.SetStateAction<boolean>>
}

// eslint-disable-next-line max-lines-per-function
const Component: React.FC<Props & WithWidthProps> = ({
  width,
  openSider: _openSider /** FIXME: 未使用？ */,
  setOpenSider
}) => {
  const login = useLogin()
  const history = useHistory()
  const submitModelDialog = useSubmitModelDialog()

  const location = useLocation()
  const isSiderHide = location.pathname === Routes.Search.path || (width && isWidthDown('sm', width))

  return (
    <>
      <Divider style={{ marginTop: isSiderHide ? '0px' : '64px' }} />
      <List dense>
        <ListItem
          button
          onClick={() => {
            history.push(Routes.Home.path)
            setOpenSider(false)
          }}
        >
          <ListItemText primary="Top" />
        </ListItem>
        <ListItem
          button
          onClick={() => {
            history.push(Routes.Help.path)
            setOpenSider(false)
          }}
        >
          <ListItemText primary="CPSYMAP Help" />
        </ListItem>
        <ListItem
          button
          onClick={() => {
            history.push(Routes.Search.path)
            setOpenSider(false)
          }}
        >
          <ListItemText primary="Visualize research papers" />
        </ListItem>
        <ListItem
          button
          onClick={() => {
            submitModelDialog.handle.handleResetState()
            submitModelDialog.handle.handleOpen()
            setOpenSider(false)
          }}
        >
          <ListItemText primary="Add new CPSY paper" />
        </ListItem>
      </List>

      <Divider />
      <List dense>
        {!login.isLoggedIn() && (
          <ListItem
            button
            onClick={() => {
              login.handleOpen()
              setOpenSider(false)
            }}
          >
            <ListItemText primary="Login / Register" />
          </ListItem>
        )}
        {login.isLoggedIn() && (
          <>
            <ListItem
              button
              onClick={() => {
                history.push(Routes.Account.path)
                setOpenSider(false)
              }}
            >
              <ListItemText primary="Review papers you added" />
            </ListItem>
            <ListItem
              button
              onClick={() => {
                login.logout()
              }}
            >
              <ListItemText primary="Logout" />
            </ListItem>
          </>
        )}
      </List>

      <Divider />
      <List dense>
        <ListItem
          button
          onClick={() => {
            history.push(Routes.Terms.path)
            setOpenSider(false)
          }}
        >
          <ListItemText primary="Terms" />
        </ListItem>
        <ListItem
          button
          onClick={() => {
            history.push(Routes.Privacy.path)
            setOpenSider(false)
          }}
        >
          <ListItemText primary="Privacy Policy" />
        </ListItem>
      </List>
      <Box padding={2} style={{ marginTop: 'auto' }}>
        <Box style={{}}>
          <Typography variant="h5" style={{}} gutterBottom>
            About us
          </Typography>
          <Typography variant="body2" style={{ fontSize: '12px' }}>
            CPSYMAP is organized by Computational Psychiatry Colloquium in Japan.
          </Typography>
        </Box>
        <Box paddingTop={2} style={{}}>
          <Typography variant="h5" style={{}} gutterBottom>
            Recommended browser
          </Typography>
          <Typography variant="body2" style={{ fontSize: '12px' }}>
            Google Chrome(PC)
          </Typography>
        </Box>
      </Box>
    </>
  )
}

export default withWidth()(Component)
